import React, { useEffect } from 'react';
import { get } from 'lodash';
import { ATMButton, ATMField, ATMForm, ATMInput } from 'shared-it-appmod-ui';
import { useFieldArray } from 'react-hook-form';
import LabelRequired from 'src/components/atoms/label-required/label-required.component';
import Lang from 'src/libraries/language';
import { SettingKey } from 'src/constants';
import { IRequestFormMethods } from 'src/models/request.model';
import { useSetting } from 'src/hooks/setting.hook';
import styles from '../flight-request-circuit.module.scss';

type IProps = IRequestFormMethods & {
  name: string;
};

const FlightRequestCircuitForm: React.FC<IProps> = ({
  name,
  control,
  errors,
}) => {
  const tieLinesCircuitsLimit = useSetting(SettingKey.MaxTieLinesCircuits, 1);
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'passengerFlight.circuitInfos',
  });

  useEffect(() => {
    if (!fields.length) {
      append({ value: '' });
    }
  }, [fields.length, append]);

  return (
    <>
      <ATMForm.Field>
        <LabelRequired>{Lang.LBL_PIPELINE_NUMBER}</LabelRequired>

        {fields.map((item, i) => (
          <div key={`circuit_${i}`} className={styles.circuit}>
            {item.circuitId && (
              <ATMField
                key={`circuitId_${item.id}`}
                as={ATMInput}
                name={`${name}[${i}].circuitId`}
                control={control}
                type="hidden"
                className="hidden"
              />
            )}

            <ATMField
              key={`value_${item.id}`}
              as={ATMInput}
              name={`${name}[${i}].value`}
              control={control}
              defaultValue={item.value}
              placeholder={Lang.LBL_ENTER}
              error={get(errors, `${name}[${i}].value`)}
            />

            {fields.length > 1 && (
              <ATMButton
                icon="trash alternate outline"
                type="button"
                onClick={() => remove(i)}
              />
            )}
          </div>
        ))}
      </ATMForm.Field>

      <ATMButton
        secondary
        type="button"
        icon="plus"
        content="Add"
        onClick={() => append({ value: '' })}
        disabled={fields.length >= tieLinesCircuitsLimit}
      />
    </>
  );
};

export default FlightRequestCircuitForm;
